module.exports = __webpack_public_path__ + "img/Artboard – 5 (1).2f6df648.png";